import React, { useEffect, useState } from 'react';
import { NewWebFooter } from './common/NewWebFooter';
import NewWebHeader from './common/NewWebHeader';
import { Link } from '@material-ui/core';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import Bridge from './constants/Bridge';
import { ViewPlan } from './Unicorn/ViewPlan';
import { LastUpdatedBadge } from './components/LastUpdatedBadge';

const Newunicornfounder = () => {
  const [filteredData, setfilterdata] = useState();
  
  function getuniondata() {
      let params = {
        page: 0,
        udPublished: "Published",
        pagesize: 10,
      };
      Bridge.Unicorn.unicorndealsByInvestors(params).then((result) => {
        // from result.data only select where isHighlighted is true
        let filtered = result.data.filter((item) => item.isHighlighted == true);
        setfilterdata(filtered);
      });
    }
    useEffect(() => {
        getuniondata();
      }, []);
    return (
      <div>
        <style>
          {`
                   
                    .hero {
                        height: 100vh;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        text-align: center;
                        background-image: url('background-image.jpg'); /* Add the background image here */
                        background-size: cover;
                        background-position: center;
                        background-color: #100050;
                    }
                    .hero h1 {
                        font-size: 4em;
                        margin-bottom: 20px;
                        color: white !important;
                    }
                    .hero p {
                        font-size: 1.5em;
                        margin-bottom: 30px;
                        color: white;
                    }
                    .buttons {
                        display: flex;
                        justify-content: center;
                        gap: 20px;
                        flex-wrap: wrap;
                    }
                    .buttons a {
                        text-decoration: none;
                        color: white;
                        background-color: #6c63ff;
                        padding: 15px 30px;
                        border-radius: 5px;
                        font-size: 1.3em;
                        transition: background-color 0.3s;
                    }
                    .buttons a:hover {
                        background-color: #574bda;
                    }

                    /* Mobile responsiveness for hero section */
                    @media (max-width: 768px) {
                        .hero {
                            height: auto;
                            min-height: 100vh;
                            padding: 20px;
                        }
                        .hero h1 {
                            font-size: 2.5em;
                            margin-bottom: 15px;
                        }
                        .hero p {
                            font-size: 1.2em;
                            margin-bottom: 25px;
                        }
                        .buttons {
                            flex-direction: column;
                            align-items: center;
                            gap: 15px;
                        }
                        .buttons a {
                            width: 100%;
                            max-width: 250px;
                            text-align: center;
                            font-size: 1.1em;
                            padding: 12px 25px;
                        }
                    }

                    @media (max-width: 480px) {
                        .hero h1 {
                            font-size: 2em;
                        }
                        .hero p {
                            font-size: 1.1em;
                        }
                        .buttons a {
                            font-size: 1em;
                            padding: 10px 20px;
                        }
                    }

                    /* Why to list section */
                    .why-to-list {
                        padding: 50px 20px;
                        text-align: center;
                        background-color: white;
                    }
                    .why-to-list h2 {
                        font-size: 2.5em;
                        margin-bottom: 40px;
                        color: white;
                    }
                    .features {
                        display: flex;
                        justify-content: center;
                        gap: 30px;
                        flex-wrap: wrap;
                    }
                    .feature-box {
                        background-color: #f5f5f5;
                        padding: 20px;
                        border-radius: 10px;
                        width: 400px;
                        max-width: 100%;
                        flex: 1;
                        min-width: 280px;
                    }
                    .feature-box h3 {
                        font-size: 1.5em;
                        margin-bottom: 10px;
                        color: #333;
                    }
                    .feature-box p {
                        font-size: 1.3em;
                        color: #666;
                    }

                    /* Mobile responsiveness for Why to list */
                    @media (max-width: 768px) {
                        .why-to-list {
                            padding: 30px 15px;
                        }
                        .why-to-list h2 {
                            font-size: 2em;
                            margin-bottom: 30px;
                        }
                        .features {
                            flex-direction: column;
                            gap: 20px;
                            align-items: center;
                        }
                        .feature-box {
                            width: 100%;
                            max-width: 350px;
                        }
                        .feature-box h3 {
                            font-size: 1.3em;
                        }
                        .feature-box p {
                            font-size: 1.1em;
                        }
                    }

                    /* Key Features Section */
                    .key-features {
                        padding: 50px 20px;
                        background-color: white;
                        color: black;
                        text-align: left;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                    }
                    .key-features h2 {
                        font-size: 2.5em;
                        text-align: center;
                        margin-bottom: 40px;
                        color: #333;
                    }
                    .features-list {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                        grid-gap: 30px;
                        margin: 20px 90px;
                        max-width: 1200px;
                        width: 100%;
                    }
                    .feature-item {
                        display: flex;
                        align-items: flex-start;
                    }
                    .feature-item-number {
                        width: 30px;
                        height: 30px;
                        background-color: #d8d8f8;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 1.5em;
                        margin-right: 20px;
                        color: #333;
                        flex-shrink: 0;
                    }
                    .feature-description {
                        max-width: 700px;
                        flex: 1;
                    }
                    .feature-description h3 {
                        font-size: 1.5em;
                        margin-bottom: 10px;
                        color: #333;
                    }
                    .feature-description p {
                        font-size: 1.3em;
                        color: #666;
                    }

                    /* Mobile responsiveness for Key Features */
                    @media (max-width: 768px) {
                        .key-features {
                            padding: 30px 15px;
                        }
                        .key-features h2 {
                            font-size: 2em;
                            margin-bottom: 30px;
                        }
                        .features-list {
                            grid-template-columns: 1fr;
                            grid-gap: 20px;
                            margin: 10px 0;
                        }
                        .feature-item {
                            align-items: flex-start;
                        }
                        .feature-item-number {
                            width: 25px;
                            height: 25px;
                            font-size: 1.2em;
                            margin-right: 15px;
                        }
                        .feature-description h3 {
                            font-size: 1.3em;
                            margin-bottom: 8px;
                        }
                        .feature-description p {
                            font-size: 1.1em;
                        }
                    }

                    @media (max-width: 480px) {
                        .features-list {
                            margin: 0;
                        }
                        .feature-item-number {
                            width: 22px;
                            height: 22px;
                            font-size: 1em;
                            margin-right: 12px;
                        }
                        .feature-description h3 {
                            font-size: 1.2em;
                        }
                        .feature-description p {
                            font-size: 1em;
                        }
                    }
                        .investor-benifit{
                        background : #ffffff;

                        }
                           .investor-benifit h2{
    color: #333;


                           }
                        /* Benefits for Founders Section */
.founder-benefit {
    background: #100050;
    padding: 50px 20px;
    text-align: center;
}

.founder-benefit h2 {
    color: #ffffff !important;
    font-size: 2.5em;
    margin-bottom: 40px;
}

.founder-benefit .features {
    display: flex;
    justify-content: center;
    gap: 30px;
    flex-wrap: wrap;
}

.founder-benefit .feature-box {
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 10px;
    width: 400px;
    max-width: 100%;
    flex: 1;
    min-width: 280px;
}

.founder-benefit .feature-box h3 {
    font-size: 1.5em;
    margin-bottom: 10px;
    color: #100050 !important;
}

.founder-benefit .feature-box p {
    font-size: 1.3em;
    color: #666;
}

/* Mobile responsiveness for Benefits for Founders */
@media (max-width: 768px) {
    .founder-benefit {
        padding: 30px 15px;
    }
    .founder-benefit h2 {
        font-size: 2em;
        margin-bottom: 30px;
    }
    .founder-benefit .features {
        flex-direction: column;
        gap: 20px;
        align-items: center;
    }
    .founder-benefit .feature-box {
        width: 100%;
        max-width: 350px;
    }
    .founder-benefit .feature-box h3 {
        font-size: 1.3em;
    }
    .founder-benefit .feature-box p {
        font-size: 1.1em;
    }
}

                `}
        </style>
        {/* <NewWebHeader /> */}
        <div classname="newabout">
          <NewWebHeader newabout={"newabout"} />
        </div>
        <section className="banner_section">
          <div
            id="carouselExampleIndicators"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <div className="container">
                  <div className="slider-area">
                    <div className="item">
                      <div className="row align-items-center">
                        <div className="col-lg-6 col-xl-24 col-sm-24">
                          <div
                            className="left-content"
                            style={{ textAlign: "center" }}
                          >
                            <h2 className="wow fadeInUp " data-wow-delay="0.3s">
                              Future Unicorns
                            </h2>
                            <span
                              className="text-white "
                              style={{ fontSize: "1.5em" }}
                            >
                              Connecting innovative startups with visionary
                              investors on Growth91 platform.
                            </span>
                            {/* <ul className="text-white">
                                                    <li><a href="Howitworks.html" className=""><span><img src="./web/images/hand-index.svg" width="24" alt="img"/> </span><u>How do i invest?</u></a></li>
                                                    <li><a href="Howitworks2.html" className=""><span></span><span><img src="./web/images/hand-index.svg" width="24"  alt="img"/> </span>What are the risks?</a></li>
                                                    <li><a href="Howitworks3.html" className=""><span></span><span><img src="./web/images/hand-index.svg" width="24"  alt="img"/> </span>What is T-SAFE?</a></li>
                                                    <li><a href="Howitworks4.html" className=""><span></span><span><img src="./web/images/hand-index.svg" width="24"  alt="img"/> </span>What are Growth91's fees?</a></li>
                                                    <span className="">
                                                      </span>
                                                </ul>                                                    --> */}

                            <form
                              className="input_box wow fadeInUp mt-4"
                              data-wow-delay="0.7s"
                            >
                              <div className="form-wraper">
                                {/* <a
                                    href="/synergy-form"
                                    className="theme-btn "
                                    type="button"
                                  >
                                    Let's Connect
                                  </a> */}
                                <NavLink
                                  to="FounderMyListing"
                                  className="theme-btn "
                                >
                                  List Your Unicorn
                                </NavLink>
                                <NavLink
                                  to="FutureUnicornList"
                                  className="theme-btn "
                                >
                                  Explore Investments
                                </NavLink>
                              </div>
                            </form>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div
                            className="right-side-images wow fadeInRight"
                            data-wow-delay="0.6s"
                          >
                            <img
                              src="./web/images/unicorn.webp"
                              class="unicorn-img"
                              alt="img"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 
            <div className="hero">
                <div>
                    <h1>Future Unicorns</h1>
                    <p>Connecting innovative startups with visionary investors on Growth91 platform.</p>
                    <div className="buttons">
                        <NavLink to="FutureUnicornForm">List Your Startup</NavLink>
                        <NavLink to="FutureUnicornList">Explore Investments</NavLink>
                    </div>
                </div>
            </div> */}

        {/* Why to list section */}

        <div class="heading-title founder-text">
          <p>
            <span></span>{" "}
          </p>
          <h2>Unicorn Spotlight</h2>
        </div>
        {/* I want below div to be only covering 80% width */}
        <div className='row justify-content-center'>
        <div className="row justify-content-center card-box col-12 col-md-12 col-lg-12 col-xl-10">
          {filteredData && filteredData.length > 0 ? (
            filteredData.map((item, index) => (
              <div key={index} className="grid-cards col-lg-4 col-md-6 col-sm-12"
                    onClick={() => {window.location.assign(`/FutureUnicornDescription?id=${item.unicornDealID}`)}}>
                <div
                  className="community-all-contents"
                  style={{
                    minHeight: "300px",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    position: "relative",
                  }}
                >
                  <div className="img-community-box">
                    <img
                      src={
                        (item.udBannerImage &&
                          `${
                            process.env.REACT_APP_BASE_URL
                          }api/uploads/unicorndeals/${
                            item.tudTempUdID
                          }/${JSON.parse(item.udBannerImage)}`) ||
                        "https://growth91.com/api/uploads/deal/banner/34/1719999515.jpg"
                      }
                      alt="Banner"
                    />
                  </div>
                  <div className="community-paragraph-box">
                    <ul>
                      <li style={{ width: "100%" }}>
                        <img
                          src={
                            (item.udLogoImage &&
                              `${
                                process.env.REACT_APP_BASE_URL
                              }api/uploads/unicorndeals/${
                                item.tudTempUdID
                              }/${JSON.parse(item.udLogoImage)}`) ||
                            "https://growth91.com/api/uploads/deal/logo/34/1719999515.jpg"
                          }
                          alt="Logo"
                        />
                        <h5>{item.udStartupName}</h5>
                      </li>
                     
                    </ul>
                     {item.udTag && item.udTag !== "None" && (
                          <div style={{ marginTop: "8px" }}>
                            {item.udTag.split(",").map((tag, tagIndex) => (
                              <span key={tagIndex} style={{
                                display: "inline-block",
                                backgroundColor: "#e6f7ff",
                                color: "#0066cc",
                                padding: "3px 10px",
                                borderRadius: "4px",
                                fontSize: "12px",
                                fontWeight: "500",
                                marginRight: "5px",
                                marginBottom: "3px"
                              }}>
                                {tag.trim()}
                              </span>
                            ))}
                          </div>
                        )}
                    <p style={{
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          display: "-webkit-box",
                        }}>{item.udDealDescription}</p>
                  </div>
                  <div
                    className="community-paragraph-box card-bottom-container"
                  >
                    <Link
                      onClick={() => {window.location.replace(`/FutureUnicornDescription?id=${item.unicornDealID}`)}}
                      // to={`/FutureUnicornDescription?id=${item.unicornDealID}`}
                      className="btn-com"
                    >
                      View More
                    </Link>
                    
                    {/* Last Updated Badge */}
                    <LastUpdatedBadge udPublishedDate={item.udPublishedDate} />
                  </div>
                </div>
              </div>
            ))
          ) : (
            <></>
          )}
        </div>
        </div>

        
        {filteredData && filteredData.length > 0 && (
          <div className="text-center mt-4">
            <button
              className="btn btn-primary btn-lg px-4 py-2 shadow-lg"
              style={{
                marginTop: "2rem",
                background: "linear-gradient(to right, #2b2f77, #4e54c8)", // Darker gradient
                border: "none",
                transition: "all 0.3s ease",
              }}
              onClick={() => {window.location.replace("/FutureUnicornList")}}
            >
              Explore all
            </button>
          </div>
        )}

        <div className="why-to-list">
          {/* <h2>Why to list?</h2> */}
          <div class="heading-title founder-text">
            <p>
              <span></span>{" "}
            </p>
            <h2>Why to list?</h2>
          </div>
          <div className="features">
            <div className="feature-box">
              <h3>Dedicated Platform</h3>
              <p>
                Future Unicorns streamlines startup listings and investor
                decision-making.
              </p>
            </div>
            <div className="feature-box">
              <h3>Comprehensive Information</h3>
              <p>Provides detailed startup profiles, pitch decks.</p>
            </div>
            <div className="feature-box">
              <h3>Investment Flexibility</h3>
              <p>
                Allows investments from NRO/Indian and NRE/overseas accounts
                with founder consent.
              </p>
            </div>
          </div>
        </div>
        <div className="why-to-list founder-benefit">
          {/* <h2>Benefits for</h2> */}
          <div class="heading-title founder-text">
            <p>
              <span></span>{" "}
            </p>
            <h2 style={{ color: "white" }}>Benefits for Founders</h2>
          </div>
          <div className="features">
            <div className="feature-box">
              <h3>Simplified Listing</h3>
              <p>Easy process to showcase startups to potential investors.</p>
            </div>
            <div className="feature-box">
              <h3>Increased Visibility</h3>
              <p>Access to a diverse investor base for greater exposure.</p>
            </div>
            <div className="feature-box">
              <h3>Global Reach</h3>
              <p>
                Potential for both domestic and international investments and
                connections.
              </p>
            </div>
          </div>
        </div>

        {/* Key Features Section */}
        <div className="key-features ">
          {/* <h2>Key Features</h2> */}
          <div class="heading-title founder-text">
            <p>
              <span></span>{" "}
            </p>
            <h2>Key Features</h2>
          </div>
          <div className="features-list">
            <div className="feature-item">
              <div className="feature-item-number">1</div>
              <div className="feature-description">
                <h3>Startup Submission Form</h3>
                <p>
                  Intuitive interface for founders to submit startup details.
                </p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-item-number">2</div>
              <div className="feature-description">
                <h3>Startup Directory</h3>
                <p>
                  Searchable database with detailed profiles and industry
                  insights.
                </p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-item-number">3</div>
              <div className="feature-description">
                <h3>Investor Dashboard</h3>
                <p>
                  Personalized recommendations and notifications for new
                  investment opportunities.
                </p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-item-number">4</div>
              <div className="feature-description">
                <h3>Security and Compliance</h3>
                <p>
                  Robust data protection and thorough startup verification
                  process.
                </p>
              </div>
            </div>
          </div>
        </div>

        <ViewPlan hideHeader/>

        <section class="custom-section" style={{marginTop:0, paddingTop: 0}}>
          <div
            class="join-section join-sec-yellow join-sec-white undefined join-divide mobile-join"
            style={{
              justifyContent: "center",
              gap: "35px",
            }}
          >
            {/* <h4>Join us</h4> */}
            <div
              className="join-flex-one-us"
              style={{ justifyContent: "center" }}
            >
              <h2 style={{ fontSize: "45px" }}>
                List your future unicorn with us
              </h2>
              {/* <p class="index_pitch">
                Decades of banking, investing & startup success guide your
                investments. Invest confidently with us.
              </p> */}
            </div>
            <div class="index-button-1" style={{ fontSize: "2rem" }}>
              <NavLink
                to="FounderMyListing"
                style={{ color: "white", fontSize: "2rem" }}
              >
                List now
              </NavLink>
            </div>
          </div>
        </section>
        <NewWebFooter />
      </div>
    );
};

export default Newunicornfounder;
